import { FormLoss } from './FormLoss'

export default FormLoss
